<template>
  <span>
    {{errs}}
    Title <input v-model='newPhoto.title'/> <br>
    Description <textarea v-model='newPhoto.description'></textarea> <br>
    Photo <input type='file' id='file' ref='file' accept="image/*" v-on:change='onFileChange' > <br>
    Photo Page <input type='checkbox' v-model='newPhoto.display'><br>
    Front Page <input type='checkbox' v-model='newPhoto.carousel'><br>
    <button @click='createPhoto()'>submit</button><br>
    <table>
      <tr>
        <th>Photo</th>
        <th>Title</th>
        <th>Description</th>
      </tr>
      <tr v-for='photo in photos' :key='photo.dateAdded'>
        <td><img v-bind:src='photo.url' width='100em' ></td>
        <td><input v-model='photo.title' /></td>
        <td><input v-model='photo.description' /></td>
        <td> Carousel <input v-model='photo.carousel' type="checkbox" /></td>
        <td> Photo Page <input v-model='photo.display' type="checkbox" /></td>
        <td>{{photo.dateTaken}}</td>
        <td>{{photo.camera}}</td>
        <td><button @click='updatePhoto(photo)'>update</button></td>
        <td><button @click='deletePhoto(photo)'>delete</button></td>
      </tr>
    </table>
  </span>
</template>
<script>
export default {
  data () {
    return {
      photos: [],
      newPhoto: {},
      file: '',
      errors: {}
    }
  },
  methods: {
    loadPhoto () {
      this.$http.get('/photos').then(response => {
        this.photos = response.data
      })
    },
    createPhoto () {
      console.log('POSTING PHOTO')
      let formData = new FormData();
      formData.append('file', this.file)
      this.$http.post(
        `/photos?key=${this.$parent.key}&photo=${JSON.stringify(this.newPhoto)}`,
        formData,
        {headers: {
          'Content-Type': 'multipart/form-data'
        }}
      ).then((res) => {
        this.loadPhoto();
        this.newPhoto = {};
        if (res.data) {
          this.errs = res.data
        }
      })
    },
    updatePhoto (photo) {
      const id = photo._id
      delete photo._id
      this.$http.put(
        `/photos/${id}?key=${this.$parent.key}&update=${JSON.stringify(photo)}`
      ).then((res) => {
        this.loadPhoto()
      })
    },
    deletePhoto (photo) {
      this.$http.delete(
        `/photos/${photo._id}?key=${this.$parent.key}`
      ).then( (res) => {
        console.log(res)
        this.loadPhoto()
      })
    },
    onFileChange() {
      this.file = this.$refs.file.files[0]
    }
  },
  mounted () {
    this.loadPhoto();
  },
  computed: {
    datetime: function(date) {
      return this.$time(date).format("YYYY-MM-DD HH:mm:ss")
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdminPhotos.vue